// ─── Mises en Pratique du module Inventaire ──────────────────────
// Contenu SPÉCIFIQUE au module (mécanique dans le Core). Clés i18n (section mep).
export const PRATIQUES_INVENTAIRE = {
  inventaire: [
    {
      id: 'premierInventaire', emoji: '📦',
      titre: 'mep.invPremT', sousTitre: 'mep.invPremS',
      etapes: [
        { consigne: 'mep.invPrem1' },
        { consigne: 'mep.invPrem2' },
        { consigne: 'mep.invPrem3' },
      ],
    },
    {
      id: 'ajouterElement', emoji: '🧮',
      titre: 'mep.invElemT', sousTitre: 'mep.invElemS',
      etapes: [
        { consigne: 'mep.invElem1' },
        { consigne: 'mep.invElem2' },
        { consigne: 'mep.invElem3' },
      ],
    },
    {
      id: 'scannerProduit', emoji: '📷',
      titre: 'mep.invScanT', sousTitre: 'mep.invScanS',
      etapes: [
        { consigne: 'mep.invScan1' },
        { consigne: 'mep.invScan2' },
        { consigne: 'mep.invScan3' },
      ],
    },
  ],
};

export default PRATIQUES_INVENTAIRE;
